import authService from '../services/auth.service'
import router from '../router'
// import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import i18n from '../i18n'

const state = { status: {}, account: null }

const actions = {
  login ({ dispatch, commit }, { username, password }) {
    commit('loginRequest', { username })
    authService.login(username, password)
      .then(
        account => {
          commit('loginSuccess', account)
          router.push('/document')
        },
        error => {
          this._vm.$toast.open({
            type: "error",
            message: i18n.t('notification.loginFailed')
          })
          commit('loginFailure', error)
        }
      )
  },
  logout ({ commit }) {
    authService.logout()
    commit('logout')
    router.push('/login')
  }
}

const mutations = {
  loginRequest (state, account) {
    state.status = { loggingIn: true }
    state.account = account
  },
  loginSuccess (state, account) {
    state.status = { loggedIn: true }
    state.account = account
  },
  loginFailure (state) {
    state.status = {}
    state.account = null
  },
  logout (state) {
    state.status = {}
    state.account = null
  }
}

export const account = {
  namespaced: true,
  state,
  actions,
  mutations
}
